import React, { Component } from "react";
import { axiosUserManagement } from "../../../axios";

import { objectToArray } from "../../../util/commonFunctions";
import { updateFormElements, checkFormValid } from "../../../util/FormHelper";
import { SiteConstants } from "../../../constants/constant";
import ForgotPasswordInit from "./ForgotPasswordInit";
import ConfirmPasswordEmail from "./ConfirmPasswordEmail";
import ForgotPasswordConfig from "../../formsConfig/ForgotPasswordConfig";
import { handleActionError } from "../../../util/error";

class ForgotPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeStep: SiteConstants.SendPassword,
      ...{ ForgotPasswordConfig },
      btnDisabled: true,
      token: null,
      resetPasswordMessage: null,
      success: false
    };
  }

  componentDidMount = () => {};

  lazyLoadComponent = stepName => {
    this.setState({
      activeStep: stepName,
      btnDisabled: true
    });
  };

  onChangeHandler = (event, formName) => {
    const updatedFrom = updateFormElements(
      event,
      event.target.getAttribute("type"),
      this.state[formName]
    );
    this.setState({
      [formName]: updatedFrom,
      btnDisabled: !checkFormValid(updatedFrom).formValid
    });
  };

  onBlurHandler = (event, formName) => {
    this.setState({
      [formName]: updateFormElements(event, "validation", this.state[formName]),
      btnDisabled: !checkFormValid(this.state[formName]).formValid
    });
  };

  ResetPasswordHandler = formName => {
    event.preventDefault();
    let returnFormConfig = checkFormValid(this.state[formName]);

    if (returnFormConfig.formValid) {
      const formData = {};
      this.setState({
        [formName]: returnFormConfig.form,
        loader: true
      });
      for (let formElementIdentifier in this.state[formName]) {
        formData[formElementIdentifier] = this.state[formName][
          formElementIdentifier
        ].value;
      }

      let searchParams = new URLSearchParams(decodeURIComponent(window.location.search));
      const config = {
        headers: {
          "cache-control": "no-cache",
          "content-type": "application/json",
          token: searchParams.has("token") ? searchParams.get("token") : ""
        }
      };
      axiosUserManagement
        .put("/forgot/password", formData, { ...config })
        .then(res => {
          this.setState({
            loader: false,
            success: true
          });
        })
        .catch(err => {
          handleActionError("An error occurred while hitting the /forgot/password PUT endpoint:", err);
          this.setState({
            loader: false,
            resetPasswordMessage: err.response.data.message
          });
        });
    } else {
      this.setState({
        [formName]: returnFormConfig.form
      });
    }
  };

  render = () => {
    return (
      <React.Fragment>
        {this.state.activeStep === SiteConstants.SendPassword && (
          <ForgotPasswordInit
            form={objectToArray(this.state.ForgotPasswordConfig)}
            formName="ForgotPasswordConfig"
            btnDisabled={this.state.btnDisabled}
            lazyLoadComponent={this.lazyLoadComponent}
            nextPage={SiteConstants.ConfirmResetPassword}
            onChangeHandler={this.onChangeHandler}
            onBlurHandler={this.onBlurHandler}
            sucessHandler={this.ResetPasswordHandler}
            resetPasswordMessage={this.state.resetPasswordMessage}
            sucessState={this.state.success}
          />
        )}
        {this.state.activeStep === SiteConstants.ConfirmResetPassword && (
          <ConfirmPasswordEmail />
        )}
      </React.Fragment>
    );
  };
}

export default ForgotPassword;
